import React, { Component } from 'react';
import classes from './CheckBox.module.css';
import Auxi from '../../../hoc/Auxi/Auxi';

export default class CheckBox extends Component {
  checkbox;
  render() {
    if (this.props.customCheckbox) {
      return (
        <Auxi>
          <label
            className={classes.CustomCheckBoxWrapper}
            onClick={this.props.onClick}
            style={this.props.styles}
          >
            {this.props.invertedCheckbox ? (
              <div
                className={classes.CheckMarkInverted}
                style={this.props.checkMarkStyles}
              >
                <svg
                  className={[
                    classes.CheckMarkInvertedIcon,
                    this.props.checked
                      ? this.props.disabled
                        ? classes.CheckMarkDisabled
                        : classes.CheckMarkInvertedChecked
                      : classes.CheckMarkInvertedUnchecked,
                  ].join(' ')}
                >
                  {this.props.checked && (
                    <use xlinkHref={'/sprites.svg#icon-check'} />
                  )}
                </svg>
              </div>
            ) : (
              <div
                className={classes.CheckMark}
                style={this.props.checkMarkStyles}
              >
                <svg
                  className={[
                    classes.CheckMarkIcon,
                    this.props.checked
                      ? this.props.disabled
                        ? classes.CheckMarkDisabled
                        : classes.CheckMarkChecked
                      : classes.CheckMarkUnchecked,
                  ].join(' ')}
                >
                  <use
                    xlinkHref={
                      this.props.checked
                        ? '/sprites.svg#icon-checkbox-checked'
                        : '/sprites.svg#icon-checkbox-empty'
                    }
                  />
                </svg>
              </div>
            )}

            <span style={this.props.labelStyles}>
              {this.props.children}
              {this.props.afterText ? (
                <span className={classes.AfterText}>
                  {' '}
                  ({this.props.afterText})
                </span>
              ) : null}
            </span>
          </label>
        </Auxi>
      );
    } else {
      return (
        <Auxi>
          <label className={classes.CheckBoxWrapper} style={this.props.styles}>
            <span style={{ marginLeft: '0.3rem' }}>
              {this.props.children}
              {this.props.afterText ? (
                <span className={classes.AfterText}>
                  {' '}
                  ({this.props.afterText})
                </span>
              ) : null}
            </span>
            <input
              ref={(ref) => {
                this.checkbox = ref;
              }}
              name={this.props.name}
              onClick={this.props.onClick}
              onChange={this.props.onClick}
              type='checkbox'
              className={classes.Checkbox}
              checked={this.props.checked}
            />
            <div className={classes.CheckMark}>
              <svg
                className={[
                  classes.CheckMarkIcon,
                  (this.checkbox && this.checkbox.checked) || this.props.checked
                    ? classes.CheckMarkChecked
                    : classes.CheckMarkUnchecked,
                ].join(' ')}
              >
                <use
                  xlinkHref={
                    (this.checkbox && this.checkbox.checked) ||
                    this.props.checked
                      ? '/sprites.svg#icon-checkbox-checked'
                      : '/sprites.svg#icon-checkbox-empty'
                  }
                />
              </svg>
            </div>
          </label>
        </Auxi>
      );
    }
  }
}
